import { AUTH_REQUEST, LOGIN_SUCCESS, REGISTER_SUCCESS, AUTH_FAILURE, LOGOUT, USER_UPDATE, PLAY_DEMO } from "../actionTypes";

const initialState = {
  token: null,
  user: null,
  loading: false,
  error: null,
  isDemo: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_REQUEST:
      return { ...state, loading: true, error: null };
    case LOGIN_SUCCESS:
    // return { ...state, loading: false, error: null };
    case REGISTER_SUCCESS:
      return { ...state, loading: false, user: action.payload.user, token: action.payload.token };
    case USER_UPDATE:
      return { ...state, loading: false, user: action.payload.user };
    case AUTH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case LOGOUT:
      return { ...state, user: null, token: null };
    case PLAY_DEMO:
      return { ...state, isDemo: action.payload };
    default:
      return state;
  }
};

export default authReducer;
